import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    jobId: Yup.number(),
    userId: Yup.number().nullable().required("Please select a User"),
    role: Yup.string().required("Please select a role for the User"),
    additionalTitle: Yup.string().nullable(),
    isFormLead: Yup.bool().nullable()
});